import { motion } from 'framer-motion';
import { Crosshair, X } from 'lucide-react';
import { STATION_SPECS } from '@/data/stations';
import type { BuildMode } from '@/state/types';

interface BuildModeBadgeProps {
  buildMode: BuildMode;
  onCancel: () => void;
}

export function BuildModeBadge({ buildMode, onCancel }: BuildModeBadgeProps) {
  if (!buildMode) return null;
  const spec = STATION_SPECS[buildMode.stationKind];
  return (
    <motion.div
      initial={{ opacity: 0, y: -12 }}
      animate={{ opacity: 1, y: 0 }}
      exit={{ opacity: 0, y: -12 }}
      transition={{ duration: 0.18, ease: 'easeOut' }}
      className="pointer-events-auto fixed left-1/2 top-20 z-30 flex -translate-x-1/2 items-center gap-3 rounded-full border border-accent-dispatch/70 bg-bg-overlay px-4 py-2 text-sm shadow-lg backdrop-blur-md md:top-3"
    >
      <Crosshair className="h-4 w-4 text-accent-dispatch" aria-hidden />
      <span>
        Klicke in die Karte, um{' '}
        <strong className="font-semibold">{spec.label}</strong> zu platzieren.
      </span>
      <button
        type="button"
        onClick={onCancel}
        className="flex items-center gap-1 rounded-full border border-border-strong bg-bg-elevated px-2 py-0.5 text-xs text-fg-muted transition hover:text-fg-primary"
      >
        <X className="h-3 w-3" aria-hidden />
        Abbrechen · ESC
      </button>
    </motion.div>
  );
}
